export default "__VITE_ASSET__BzslU1jP__"